import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const Services = () => {
  const { t } = useTranslation();
  const [selectedService, setSelectedService] = useState(null);
  const [isClosing, setIsClosing] = useState(false);

  const services = [
    {
      image: "/images/road.jpg",
      popupImage: "/images/customsprocedures.jpg",
      title: "services.card1Title",
      description: "services.card1Description",
      link: "services.learnMore",
      details: "services.card1details",
    },
    {
      image: "/images/truck.jpg",
      popupImage: "/images/transport.jpg",
      title: "services.card2Title",
      description: "services.card2Description",
      link: "services.learnMore",
      details: "services.card2details",
      email: t("ourTeam.transport.mail"),
      phone: t("ourTeam.transport.number"),
    },
    {
      image: "/images/box.jpg",
      popupImage: "/images/carinskisklad.jpg",
      title: "services.card3Title",
      description: "services.card3Description",
      link: "services.learnMore",
      details: "services.card3details",
      email: t("ourTeam.carinskiSkladRakovoditel.mail"),
      phone: t("ourTeam.carinskiSkladRakovoditel.number"),
    },
    {
      image: "/images/Handshake.jpg",
      popupImage: "/images/consulting.jpeg",
      title: "services.card4Title",
      description: "services.card4Description",
      link: "services.learnMore",
      details: "services.card4details",
    },
    {
      image: "/images/building.jpg",
      popupImage: "/images/izdavanje.jpeg",
      title: "services.card5Title",
      description: "services.card5Description",
      link: "services.learnMore",
      details: "services.card5details",
    },
    {
      image: "/images/coldpharma.png",
      popupImage: "/images/cold warehouse.jpg",
      title: "services.card6Title",
      description: "services.card6Description",
      link: "services.learnMore",
      details: "services.card6details",
    },
  ];

  const handleOpenPopup = (service) => {
    setSelectedService(service);
    document.body.classList.add("no-scroll");
  };

  const handleClosePopup = () => {
    setIsClosing(true);
    setTimeout(() => {
      setSelectedService(null);
      setIsClosing(false);
      document.body.classList.remove("no-scroll");
    }, 500);
  };

  return (
    <section id="services" className="px-5 max-w-[1290px] w-full mx-auto mt-32">
      <div className="mx-auto">
        <p className="font-[700] text-[16px] leading-[20.8px] text-[#4F4F4F]">
          {t("services.services")}
        </p>
        <div className="flex flex-col lg:w-[40%]">
          <h2 className="text-[27.65px] leading-[33.18px] font-[900] text-[#111111] mb-4 mt-10">
            {t("services.title")}
          </h2>
          <p className="text-[#3D3D3D] mb-6 text-[16px] leading-[20.8px] font-[400]">
            {t("services.description")}
          </p>
        </div>
        <a
          href="/contactus"
          className="flex w-[120px] items-center justify-center gap-2 p-[10px_24px] rounded-[12px] bg-[#FEEED6] text-[#F67E20] hover:bg-[#F67E20] hover:text-[#FEEED6] font-medium transition-all duration-300 ease-in-out"
        >
          {t("nav.contact")} <i className="fas fa-arrow-right ml-2"></i>
        </a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-32">
        {services.map((service, index) => (
          <div key={index} className="text-left pb-10">
            <img
              src={service.image}
              alt={service.title}
              className={`mb-4 ${index === 1 ? "w-12 h-10" : "w-10 h-10"}`}
              loading="lazy"
            />
            <h3 className="text-[19.2px] leading-[24.96px] font-[700] text-[#111111] mb-2">
              {t(service.title)}
            </h3>
            <p className="text-[#3D3D3D] mb-4 text-[16px] font-[400] leading-[20.8px]">
              {t(service.description)}
            </p>
            <button
              onClick={() => handleOpenPopup(service)}
              className="text-[#F7983F] text-[16px] font-[700] leading-[20.8px] underline"
            >
              {t(service.link)}
            </button>
          </div>
        ))}
      </div>

      {selectedService && (
        <div
          className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 ${isClosing ? "animate-fade-out" : "animate-fade-in"}`}
        >
          <div
            className={`bg-white rounded-lg p-4 sm:p-8 lg:p-12 w-[95%] sm:w-[90%] lg:w-[70%] xl:w-[60%] max-h-[90vh] overflow-y-auto flex flex-col sm:flex-row gap-4 sm:gap-6 relative ${isClosing ? "animate-slide-out" : "animate-slide-in"}`}
          >
            <button
              onClick={handleClosePopup}
              className="absolute top-1 right-1 sm:top-2 sm:right-2 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
            <div className="sm:w-1/2 flex flex-col justify-center order-2 sm:order-1">
              <h3 className="text-[20px] font-bold mb-4">{t(selectedService.title)}</h3>
              <p className="text-[#3D3D3D] mb-4">{t(selectedService.details)}</p>
              {selectedService.email && (
                <p className="text-[#3D3D3D] mb-2">
                  <strong>{t("services.email")}:</strong> {selectedService.email}
                </p>
              )}
              {selectedService.phone && (
                <p className="text-[#3D3D3D] mb-2">
                  <strong>{t("services.phone")}:</strong> {selectedService.phone}
                </p>
              )}
            </div>
            <div className="sm:w-1/2 flex justify-center items-center order-1 sm:order-2">
              <img
                src={selectedService.popupImage}
                alt={t(selectedService.title)}
                className="w-full h-48 sm:h-56 lg:h-64 object-cover object-center rounded-lg"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      )}

      <span className="w-full block h-[1px] bg-[#DCDCDC] mt-20 mb-20"></span>
    </section>
  );
};

export default Services;
